module.exports = __webpack_public_path__ + "img/mIconFolder.8429edc9.svg";